/**
 * 自定义报表
 */

import { HTTP_ALB } from '../axios'

//  自配置字段列表
export const self_config_list = params => {
  return HTTP_ALB.get('/data/live/self_config_list', params)
}

// 自定义字段列表
export const custom_field_list = params => {
  return HTTP_ALB.get('/data/live/custom_field_list', params)
}
// 添加自配置字段
export const add_self_config = params => {
  return HTTP_ALB.post('/data/live/add_self_config', params)
}
// 自配置字段详情
export const self_config_info = params => {
  return HTTP_ALB.get('/data/live/self_config_info', params)
}

//  自配置字段规则列表
export const self_config_rule_list = params => {
    return HTTP_ALB.get('/data/live/self_config_rule_list', params)
  }
  
  // 添加自配置字段规则
  export const add_self_config_rule = params => {
    return HTTP_ALB.post('/data/live/add_self_config_rule', params)
  }
  // 自配置字段规则详情
  export const self_config_rule_info = params => {
    return HTTP_ALB.get('/data/live/self_config_rule_info', params)
  }
  // 自配置字段规则编辑
  export const edit_self_config_rule = params => {
    return HTTP_ALB.post('/data/live/edit_self_config_rule', params)
  }

    // 添加自定义字段
export const add_custom_filed = params => {
    return HTTP_ALB.post('/data/live/add_custom_filed', params)
  }
  // 自定义列列表
  export const get_custom_column = params => {
    return HTTP_ALB.get('/data/live/get_custom_column', params)
  }
  // 直播间报表
  export const custom_live_data = params => {
    return HTTP_ALB.get('/data/live/custom_live_data', params)
  }

    // 直播间报表场次数据
export const live_data_session = params => {
    return HTTP_ALB.get('/data/live/live_data_session', params)
  }
  // 获取默认字段
  export const get_default_field = params => {
    return HTTP_ALB.get('/data/live/get_default_field', params)
  }


      
